import { Link } from "react-router-dom";

/* RollingHero — continuous left-scrolling marquee of Mike's lifestyle &
   product images. Sits ABOVE the existing Landing hero so it's the very
   first thing visitors see.

   Implementation notes:
   - Uses pure CSS keyframe animation (no JS) for buttery smooth scroll
     and zero re-render overhead.
   - Duplicates the image array twice in the DOM so when the first set
     scrolls off the left edge, the second set is already visible on the
     right — no visible "snap" or gap. The whole strip is exactly 2× the
     image set width and animates from translateX(0) → translateX(-50%).
   - Each tile is 280×280 on desktop / 200×200 on mobile so 5–6 tiles are
     visible at once on a typical screen.
   - Cream background + thin gold caption strip below ("FAITH · WELLNESS ·
     INCOME · 60% COMMISSION") that does NOT scroll.
   - Pauses on hover so seniors can read a card they're interested in. */

const O    = "#F39A1F";
const WINE = "#0F172A";

/* Mike's uploaded lifestyle + product images. Each is captioned with the
   message it conveys + a CTA hint. Square aspect — tiles tile cleanly. */
const SLIDES = [
  /* ── Flagship Book — With Faith All Things Are Possible (BOOK + COURSE + AUDIO bundle) ── */
  {
    img: "/with-faith/bundle-hero.png",
    caption: "With Faith All Things Are Possible · Book + Course + Audio · By Michael Boyd",
    accent: "#2E9F3A",
    to: "/with-faith",
  },
  /* ── NEW · GoGreen Hemp CBD (Awin affiliate) ── */
  {
    img: "https://customer-assets.emergentagent.com/job_grace-community-plus/artifacts/dhv5be2b_Screenshot%202026-06-06%20124437.png",
    caption: "GoGreen Hemp · Broad-Spectrum CBD · New In The Market",
    accent: "#2E9F3A",
    to: "/market#supplements",
  },
  /* ── NEW · Bee&You bee products (Refersion affiliate) ── */
  {
    img: "https://customer-assets.emergentagent.com/job_grace-community-plus/artifacts/o08i64t2_Screenshot%202026-06-06%20125500.png",
    caption: "Bee&You · Raw Honey · Royal Jelly · Propolis · Immunity",
    accent: "#F39A1F",
    to: "/market#supplements",
  },
  /* LiveGood removed Feb 2026 (Mike pulled — MLM concerns). */
  {
    img: "https://customer-assets.emergentagent.com/job_grace-community-plus/artifacts/gzwud02k_is%20this%20high%20quality%20enoug.png",
    caption: "Get Healthy",
    accent: "#C5111D",
  },
  {
    img: "https://customer-assets.emergentagent.com/job_grace-community-plus/artifacts/mn0rnl85_goli%20ad%203.png",
    caption: "Goli — Earn 60% Per Bottle",
    accent: "#C5111D",
  },
  {
    img: "https://customer-assets.emergentagent.com/job_grace-community-plus/artifacts/uacc84vv_goli%20ad%202.png",
    caption: "Goli Gummies — So Squishy, So Sellable",
    accent: "#C5111D",
  },
  {
    img: "https://customer-assets.emergentagent.com/job_grace-community-plus/artifacts/r30acljf_goli%20ad%204.png",
    caption: "Goli — Daily Wellness, Daily Income",
    accent: "#C5111D",
  },
  {
    img: "https://customer-assets.emergentagent.com/job_grace-community-plus/artifacts/yja9xjke_HYDROGEN%20WATCH%20BOTTLE.png",
    caption: "Portable Hydrogen Water — Earn 60%",
    accent: "#287F8E",
  },
  {
    img: "https://customer-assets.emergentagent.com/job_grace-community-plus/artifacts/7bcbtrxe_HYDROGEN%20WATER%20PITCHER.png",
    caption: "Hydrogen Water At Home — Earn 60%",
    accent: "#287F8E",
  },
  {
    img: "https://customer-assets.emergentagent.com/job_grace-community-plus/artifacts/wvep88hq_SENIORS%20EXERCISING.png",
    caption: "Active. Healthy. Faithful.",
    accent: "#2E9F3A",
  },
  {
    img: "https://customer-assets.emergentagent.com/job_grace-community-plus/artifacts/bakwqtot_TAKING%20CARE%20OF%20SENIORS.png",
    caption: "Caring For Our Loved Ones",
    accent: "#0F172A",
  },
  /* Brainzyme removed Feb 2026 (Mike's call). */
  {
    img: "https://customer-assets.emergentagent.com/job_grace-community-plus/artifacts/4kd1idsy_tshirt%20ad1.png",
    caption: "Built By God · Powered By Jesus",
    accent: WINE,
  },
  {
    img: "https://customer-assets.emergentagent.com/job_grace-community-plus/artifacts/i2zccdz5_JESUS%20IS%20THE%20ONLY%20REASON%20I%20MADE%20IT%20THIS%20FAR%20tshirt%20ad.png",
    caption: "Christian Tees — Earn 60% Per Shirt",
    accent: "#0F1E3D",
  },
  {
    img: "https://customer-assets.emergentagent.com/job_grace-community-plus/artifacts/cpnelzl5_coloring%20pages%20ad%201.png",
    caption: "Free Coloring Pages For Kids",
    accent: "#287F8E",
  },
  /* ── Affiliate Marketing 101 promo tiles ── */
  {
    img: "/courses/aff101-tile-couple-laptop.png",
    caption: "10 Lessons. Real Faith. Real Income.",
    accent: WINE,
    to: "/business/affiliate-marketing-101",
  },
  {
    img: "/courses/aff101-tile-editorial-cover.png",
    caption: "The Faitharama Affiliate Playbook · Free To Read",
    accent: "#0F172A",
    to: "/business/affiliate-marketing-101",
  },
  {
    img: "/marquee/faitharama-merch.png",
    caption: "Faitharama Merchandise · Hats · Tees · Tumblers · Phone Cases",
    accent: "#2E9F3A",
    to: "/market",
  },
  /* ── New affiliate partners (May 2026) ── */
  {
    img: "https://customer-assets.emergentagent.com/job_grace-community-plus/artifacts/bwtnt7uv_Screenshot%202026-05-26%20154337.png",
    caption: "The Home Doctor · Practical Medicine For Every Household",
    accent: "#C5111D",
    to: "/market#supplements",
  },
  {
    img: "https://customer-assets.emergentagent.com/job_grace-community-plus/artifacts/yn1tyvgr_Screenshot%202026-05-26%20160531.png",
    caption: "The Smoothie Diet · 21-Day Program · Earn Per Sale",
    accent: "#7BC24C",
    to: "/market#supplements",
  },
  {
    img: "https://customer-assets.emergentagent.com/job_grace-community-plus/artifacts/dqggyq74_Screenshot%202026-05-26%20161425.png",
    caption: "Reflux Online Summit 2026 · Earn a commission Per Sale",
    accent: "#1E6BB8",
    to: "/market#supplements",
  },
  {
    img: "/partners/prostavive.png",
    caption: "ProstaVive · Prostate Health · Earn 75–80% Per Sale",
    accent: "#3074FF",
    to: "/market#supplements",
  },
  {
    img: "/partners/jointgen.png",
    caption: "JointGen · Japanese Joint Formula · High Affiliate Payout",
    accent: "#A77B34",
    to: "/market#supplements",
  },
  {
    img: "/partners/simple-slim-kitchen.png",
    caption: "The Simple Slim Kitchen · 62 Recipes + 30-Day Meal Plan",
    accent: "#397F44",
    to: "/market#supplements",
  },
];

export default function RollingHero() {
  /* Render the slide list twice back-to-back. The CSS keyframe scrolls
     the whole flex row by exactly -50% so the second copy seamlessly
     takes over visually. */
  const doubled = [...SLIDES, ...SLIDES];

  return (
    <section
      className="relative overflow-hidden"
      style={{ background: "linear-gradient(180deg, #FFFFFF 0%, #EAF6FC 100%)" }}
      data-testid="rolling-hero"
    >
      {/* Inline keyframes so this works without touching tailwind config */}
      <style>{`
        @keyframes faitharama-marquee {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .fh-marquee-track {
          animation: faitharama-marquee 60s linear infinite;
          will-change: transform;
        }
        .fh-marquee:hover .fh-marquee-track {
          animation-play-state: paused;
        }
        @media (prefers-reduced-motion: reduce) {
          .fh-marquee-track { animation-duration: 180s; }
        }
      `}</style>

      {/* Soft edge fade — left & right gradient overlay that hides
          the abrupt edge of off-screen tiles. Pointer-events none so
          clicks still pass through to tiles underneath. */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-0 z-10 w-20 md:w-32"
           style={{ background: "linear-gradient(90deg, #FFFFFF 0%, rgba(255,253,247,0) 100%)" }}/>
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 right-0 z-10 w-20 md:w-32"
           style={{ background: "linear-gradient(270deg, #FFFFFF 0%, rgba(255,253,247,0) 100%)" }}/>

      <div className="fh-marquee py-6 md:py-8" data-testid="rolling-hero-track-wrap">
        {/* The scrolling strip itself */}
        <div className="fh-marquee-track flex gap-4 md:gap-5 w-max" data-testid="rolling-hero-track">
          {doubled.map((slide, idx) => (
            <Link
              key={`${slide.img}-${idx}`}
              to={slide.to || "/market"}
              className="block relative rounded-2xl overflow-hidden shadow-lg bg-white flex-shrink-0 group hover:shadow-2xl transition-shadow"
              style={{
                width: "clamp(210px, 22vw, 300px)",
                height: "clamp(210px, 22vw, 300px)",
                border: `3px solid ${slide.accent}33`,
              }}
              data-testid={`rolling-hero-slide-${idx}`}
              aria-label={slide.caption}
            >
              <img
                src={slide.img}
                alt={slide.caption}
                className="block w-full h-full object-contain p-3 group-hover:scale-[1.04] transition-transform duration-700"
                loading="lazy"
              />
              {/* Bottom caption ribbon — appears INSIDE each tile */}
              <div className="absolute inset-x-0 bottom-0 px-3 py-2 text-center"
                   style={{
                     background: "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.78) 100%)",
                   }}>
                <div className="text-[11px] md:text-xs tracking-[0.18em] uppercase font-bold leading-tight"
                     style={{ color: "#FFFFFF", textShadow: "0 2px 8px rgba(0,0,0,0.6)" }}>
                  {slide.caption}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Caption strip — static, sits below the marquee */}
      <div className="relative px-5 pb-5 md:pb-6 text-center" data-testid="rolling-hero-caption">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-[10px] md:text-[11px] tracking-[0.32em] uppercase font-bold shadow"
             style={{ background: "#0F172A", color: O }}>
          ★ FAITH · WELLNESS · INCOME · 50/50 SPLIT ★
        </div>
      </div>
    </section>
  );
}
